import { createApp } from 'vue';
import App from './App.vue';
import './styles/main.css';
import { loadConfig } from './composables/useConfig';

async function bootstrap(): Promise<void> {
  await loadConfig();
  createApp(App).mount('#app');
}

void bootstrap();
